<template>
  <div class="pa-7" id="performance">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
    <v-row>
      <v-col cols="12">
      <p>
        ・国立大学医学部 医学科向け授業用
      </p>
      <p>
        ・国立大学病院 pmark教育用
      </p>
      <p>
        ・国立大学病院 ISO9001教育用
      </p>
      </v-col>
    </v-row>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}

.summary {
  vertical-align: middle;
  font-size: 16px;
}
v-list-item{
  margin-bottom:-8px;
}
p{
  border-bottom:solid 1px #BBDE;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '実績',
      // タイトル横のアイコン
      icon: 'mdi-clipboard-text-outline'
    }
  }
}
</script>
